import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { Error } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: "16px",
    padding: "16px",
    maxWidth: "380px",
    width: "100%",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    padding: "12px 8px",
  },
  icon: {
    fontSize: "56px",
    color: "#D32F2F",
    marginBottom: "16px",
  },
  title: {
    fontWeight: "bold",
    fontSize: "20px",
    color: "#1A1F36",
    marginBottom: "12px",
  },
  description: {
    fontSize: "14px",
    color: "#4F5B76",
    lineHeight: "1.5",
    marginBottom: "24px",
  },
  deleteButton: {
    backgroundColor: "#D32F2F",
    color: "#FFFFFF",
    width: "100%",
    height: "46px",
    borderRadius: "8px",
    textTransform: "none",
    fontWeight: "bold",
    fontSize: "15px",
    marginBottom: "8px",
    "&:hover": {
      backgroundColor: "#B71C1C",
    },
  },
  cancelButton: {
    color: "#1A73E8",
    width: "100%",
    height: "40px",
    textTransform: "none",
    fontWeight: "bold",
    fontSize: "15px",
    "&:hover": {
      backgroundColor: "rgba(26, 115, 232, 0.04)",
    },
  },
}));

const ReportDeleteConfirmDialog = ({ open, onClose, onConfirm, selectedCount }) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: classes.dialogPaper }}
      aria-labelledby="delete-confirm-dialog-title"
    >
      <DialogContent>
        <Box className={classes.container}>
          <Error className={classes.icon} />
          <Typography className={classes.title} id="delete-confirm-dialog-title">
            Delete {selectedCount} {selectedCount === 1 ? "Report" : "Reports"}?
          </Typography>
          <Typography className={classes.description}>
            This action cannot be undone. The selected {selectedCount === 1 ? "report" : "reports"} will be permanently removed.
          </Typography>
          <Button
            className={classes.deleteButton}
            variant="contained"
            onClick={onConfirm}
          >
            Delete
          </Button>
          <Button
            className={classes.cancelButton}
            onClick={onClose}
          >
            Cancel
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ReportDeleteConfirmDialog;
